import { render, staticRenderFns } from "./MyCustomer.vue?vue&type=template&id=33569daa&scoped=true"
import script from "./MyCustomer.vue?vue&type=script&lang=js"
export * from "./MyCustomer.vue?vue&type=script&lang=js"
import style0 from "./MyCustomer.vue?vue&type=style&index=0&id=33569daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33569daa",
  null
  
)

export default component.exports